<template>
  <div class="home">
    <v-row justify="center">
      <div class="player-container">
        <vue-core-video-player muted z-index=-1 :src="require(`@/assets/video.mp4`)"></vue-core-video-player>
      </div>
    </v-row>
    <v-container>
      <v-row class="mt-2" justify="center">
        <v-col cols="2" class="hidden-sm-and-down" >
          
          <v-list class="mt-2 submenu" color="#fafafa" subheader dense>
            <v-subheader>目次</v-subheader>
            <v-list-item @click="smoothScroll('overview')">概要</v-list-item>
            <v-list-item @click="smoothScroll('keyword')">研究キーワード</v-list-item>
            <v-list-item @click="smoothScroll('content')">研究内容</v-list-item>
            <v-list-item @click="smoothScroll('tostudent')">学部生へ</v-list-item>
            <v-list-item to="/voice">学生の声</v-list-item>
            <v-list-item to="/question">Q&A</v-list-item>
            <v-list-item @click="smoothScroll('news')">News</v-list-item>
          </v-list>
        </v-col>

        <v-col cols="10">
          <v-row class="mt-2" justify="center">
            <!-- カルーセル -->
            <v-col cols="12" md="10">
              <v-carousel class="carousel" height="auto" hide-delimiters>
                <v-carousel-item v-for="(item, i) in items" :key="i" :src="item.src">
                </v-carousel-item>
              </v-carousel>
            </v-col>
          </v-row>

          <v-row class="mt-2" justify="center">
            <v-col cols="12" md="10">
              <div id="overview" style="padding-top: 20px;" class="heading text-h4 pl-4 mt-8" >
                概要
              </div>
            </v-col>
          </v-row>
          <div class="mt-2">
            <v-row justify="center">
              <v-col cols="12" md="10">
                <div class="mt-2">
                  高信頼マルチモーダル感性知能と知識工学研究室（TMAK: Trustworthy Multimodal Affective Intelligence and Knowledge Engineering Lab）は
                  <a href="https://www.tokushima-u.ac.jp/st/graduate_school/course/intelligent_information/" target="_blank">
                  徳島大学 創成科学研究科 理工学専攻 知能情報システムコース
                  </a>
                  所属の研究室です。
                  学部は<a href="http://www.is.tokushima-u.ac.jp/wp/" target="_blank">理工学部 理工学科 知能情報コース</a>
                  になります。
                </div>
              </v-col>
            </v-row>
          </div>

          <v-row class="mt-2" justify="center">
            <v-col cols="12" md="10">
              <div id="keyword" style="padding-top: 20px;" class="heading text-h4 pl-4 mt-8">
                研究キーワード
              </div>
            </v-col>
          </v-row>
          <div class="mt-2">
            <v-row justify="center">
              <v-col cols="12" md="10">
                <ul class="list mt-2">
                  <li>マルチメディア情報検索 (multimedia information retrieval)</li>
                  <li>音楽情報処理 (music information processing)</li>
                  <li>音声情報処理 (speech information processing)</li>
                  <li>音声ドキュメント検索 (spoken document retrieval)</li>
                  <li>音響指紋 (audio fingerprinting)</li>
                  <li>自然言語処理 (natural language processing)</li>
                  <li>テキストマイニング (text mining)</li>
                  <li>ディープラーニング (deep learning)</li>
                  <li>類似画像検索(similar image retrieval)</li>
                  <li>感性情報処理 (affective computing)</li>
                  <li>感情認識 (emotion recognition)</li>
                  <li>情報抽出(information extraction)</li>
                  <li>Web文書解析 (web document analysis)</li>
                  <li>健康情報マイニング (health information mining)</li>
                  <li>ソーシャルメディア解析 (social media analysis)</li>
                  <li>脳波解析 (EEG analysis)</li>
                  <li>高速検索技術 (fast retrieval technique)</li>
                  <li>イラスト画像分類 (illustration image classification)</li>
                  <li>マルチモーダル感性計算 (Multi-Modal Affective Computing)</li>
                  <li>信頼できる人工知能 (Trustworthy AI)</li>
                  <li>知識工学(Knowledge Engineering)</li>
                  <li>健康工学(Health Technology)</li>
                  <li>金融工学(Finance Technology)</li>
                </ul>
              </v-col>
            </v-row>
          </div>

          <v-row class="mt-2" justify="center">
            <v-col cols="12" md="10">
              <div id="content" style="padding-top: 20px;" class="heading text-h4 pl-4 mt-8 anchor">
                研究内容
              </div>
            </v-col>
          </v-row>

          <div class="mt-2">
            <v-row justify="center">
              <v-col cols="12" md="10">
                <div class="mt-2">
                自然言語処理技術や感性情報処理技術を用いてWeb上のテキストマイニングや感情分析，
                生活習慣分析などをテーマにした研究を行っています。
                以下は，卒業研究テーマの一例です。
                </div>
                <ul class="list mt-2">
                  <li class="mt-2">会話・感情解析</li>
                    会話における人物の感情状態や人物間の関係（親しさ等）を推定します．
                    ユーザの性別や年齢，職業，パーソナリティに適応させて感情推定する手法，
                    小説や歌詞の感情推定，
                    対話促進のためのインタビュー対話システム，
                    性格一貫性を重視した対話モデルの構築，
                    被介護者とロボットの対話感情分析についても研究します．<br>
                    また，マルチモーダル情報（表情・音声・動作）と感情および思考過程の注釈を付与した
                    統合失調症患者のデータベース構築やうつ病予測の研究なども行います．
                  <li class="mt-2">リモートワーカーのストレス検出</li>
                    遠隔勤務している労務者のストレス評価結果と動画像から推定した感情などから，ストレス状態を予測する手法を開発します．
                  <li class="mt-2">視聴者コメントからのイベントシーン検索</li>
                  動画共有サイトにおける投稿コメントやTV放送の視聴者の実況ツイートをもとに動画の注目イベントシーンを検索する手法について研究します．
                  <li class="mt-2">テキスト中の非言語表現の認識</li>
                  Web上の発言に混在する顔文字・絵文字・アスキーアートといった非言語表現を対象とした意味解析技術について研究を行います．
                  <li class="mt-2">テキストマイニング</li>
                  ツイッターにおける位置情報や，レビューサイトの星の数といった数値情報と言葉の関連性を分析し，
                  場所や評判に特徴的な言葉の自動抽出を目指します．また，Webや論文に書かれている表から，
                  それらがどのような意味で書かれているのかを自動的に解析するシステムの実現を目指します．
                  また，ツイッターのプロフィール情報等を利用し，文書の書き手がその分野の専門家であるか否かを判定するシステムや，
                  専門家と非専門家による文書の違い等の分析を行います．そのほか，テキスト中のトピック分析や数値表現の意味理解，
                  ツイッターのプロフィール情報を利用したコミュニティ抽出等についても研究します．また，人物の心情や行動に着目した物語の要約，
                  深層学習技術を応用した情報推薦や趣味分類，アプリのレビュー分類などにも取り組んでいます．
                  た，ソーシャルメディアにおける投稿内容や投稿者の属するコミュニティなどからの炎上や流行を予測する研究を行います．
                  <li class="mt-2">健康・災害・感染症動向マイニング</li>
                    ツイッター，ブログ等の個人によるビッグテキストデータと，
                    公的機関や病院等の公式のWebサイトの双方から健康情報や感染症の発生動向，災害の被害状況等の情報を抽出し，
                    リアルタイム性と網羅性に優れた健康や災害に関する情報の抽出および予測システムの実現を目指します．
                    また、ツイッターの投稿を分析することで，食事や睡眠等，ユーザ自身の生活習慣を自動分析し，
                    健康管理に役立てる研究も行います．
                    炎上や情報漏洩を防止するために対話データやSNS上のデータから個人を特定できるような生活習慣や個人情報を抽出し，
                    マスキングする処理について研究します。さらに，糖尿病をはじめとする生活習慣病患者の闘病ブログや，
                    対話ロボットとの対話履歴内容から生活習慣（食事，運動，仕事，行動など）を解析し，その結果と健康/精神状態の推移との関連に基づき，
                    生活習慣の改善・悪化の要因を自動分析・生活習慣病のリスクを発見/改善案を提示するシステムを開発します．
                  <li class="mt-2">対話型情報検索・推薦システム</li>
                    近年話題のAIチャットボットを応用し，対話型の情報検索・推薦システムを開発します．
                    カウンセリングやインタビュー対話のテクニックを応用し，話題を掘り下げていったり，
                    検索対象を明確化していくために，対話における言語情報に加え，画像や絵文字，
                    WebURLなどの情報を利用してマルチモーダル情報解析による実現を目指します．
                </ul>
                <div class="mt-2">
                当研究室はデータサイエンス技術，深層学習，マルチメディア情報検索，自然言語処理，テキストマイニング，音声対話システム，感性情報処理などの最新技術を用いた研究を行っています．様々なメディア，テーマを対象として研究を行っているため，多様な技術に触れながら知識や技術を高めていくことが可能です．学生主体の新たな研究テーマ発足にも意欲的であり，自分のやってみたい研究テーマがあればそれをサポートし，実現するためのアドバイスが得られる環境が整っています．
                </div>
              </v-col>
            </v-row>
            
            <v-row justify="center">
              <v-col cols="12" md="10">
                <div class="text-h6 text-sm-h5 font-weight-bold pl-4">助成</div>
              </v-col>
            </v-row>
            <v-row class="my-4" justify="center">
              <v-col cols="7" md="4">
                <a href="https://www.jka-cycle.jp/" target="_blank">
                  <v-img :src="require(`@/assets/logo/jka_cycle.png`)"></v-img>
                </a>
              </v-col>
              <v-col cols="7" md="4">
                <a href="http://keirin.jp/pc/top" target="_blank">
                  <v-img :src="require(`@/assets/logo/keirin_jp.png`)"></v-img>
                </a>
              </v-col>
            </v-row>

          </div>

          <v-row class="mt-2" justify="center">
            <v-col cols="12" md="10">
              <div id="tostudent" style="padding-top: 20px;" class="heading text-h4 pl-4 mt-8 anchor">
                学部生へ
              </div>
            </v-col>
          </v-row>

          <div class="mt-2">
            <v-row justify="center">
              <v-col cols="12" md="10">
                <div class="mt-2">
                  <ul>
                    <li class="mt-2">教員からのメッセージ</li>
                    当研究室は，令和5年度より，松本准教授と吉田講師が2名体制で運営している研究室です。<br>
                    令和2年に，それまでのマルチメディア情報検索主体の研究室から独立し，
                    感性・言語・対話・健康情報解析を主軸として，独立基盤形成により，
                    新たな研究設備を整えることで研究室を起ち上げました。<br>
                    まだまだ生まれて間もない研究室ですので，研究室のカラーが明確に定まっていませんが，
                    これから私たちと一緒に次世代の研究テーマに取り組んでみませんか？
                    研究のテクニック，スキルは研究室に入ってからでも磨けます。<br>
                    新しい技術を独自に開発してみたい，新規性・独創性のある研究をしてみたい，
                    今までにないまったく新しいシステムを自分の手で創り出してみたいといった，やる気のある方を募集しています！<br>
                    研究室在室の大学院生（博士前期，後期課程）と学部生以外に，共同研究先の企業研究者や，
                    医学部の研究者，他大学，高等専門学校，他研究機関の異分野研究者との共同研究も積極的に推進しています。<br>
                    研究室選びに迷ったら，A2研究室を選んでください。<br>
                    <br>
                     <li class="mt-2">学生からのメッセージ</li>
                    A2研究室は穏やかな雰囲気な研究室で
                    先生方が優しく指導して下さります。<br>
                    「初めての研究、どう進めていけばいいのかわからない！」<br>
                    「自分の力を試すときが来た！」<br>
                    そんな方々が自分のペースで研究を進めていくことができます。<br>
                    「何の研究をしてるの？」→ <a href="/research" target="_blank">研究</a>，
                    <a href="/publications" target="_blank">発表文献</a><br>
                    「設備はどんなもん？」→ <a href="/facility" target="_blank">設備</a><br>
                    「どのくらい人いるの？」→ <a href="/members" target="_blank">メンバー</a><br>
                    「雰囲気は？」 → <a href="/voice" target="_blank">学生の声</a><br>
                    A2研究室についてのQ&Aはこちら→<a href="/question" target="_blank">Q&A</a><br>
                    興味がある方はいつでもA2研究室（<a href="/access" target="_blank">総合科学実験棟7階701室</a>）へお越しください。<br>
                    研究室訪問も随時受け付けています！→<a href="https://forms.gle/ccxPGHzU8iKgPC2v5" target="_blank">研究室訪問申請フォーム</a> <br>
                    ※学部生は3年の後期に研究室配属となります。<br>
                    ※GPAの高い人から順に所属する研究室が決まるらしいです。
                  </ul>
                </div>
              </v-col>
            </v-row>
          </div>

          <v-row class="mt-2" justify="center">
            <v-col cols="12" md="10">
              <div id="news" style="padding-top: 20px;" class="heading text-h4 pl-4 mt-8 anchor">
                News
              </div>
            </v-col>
          </v-row>

          <div class="mt-2">
            <v-row justify="center">
              <v-col cols="12" md="10">
                <v-list class="overflow-y-auto" max-height="500" color="#fafafa">
                  <v-list-item v-for="(item, index) in infos" :key="index" :to="item.link">
                    <v-list-item-content>
                      <v-list-item-title style="white-space: pre-line">{{formatDate(item.date)}} {{ item.title }}</v-list-item-title>
                      <v-list-item-subtitle style="white-space: pre-line">{{ item.subtitle }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </div>

        </v-col>
      </v-row>

      <!-- <v-row class="mt-2" v-for="info in this.informations.datas" :key="info.id">
        <v-col cols="4" offset="1" xl="2" offset-xl="2">
          <div class="info white--text">お知らせ</div>
        </v-col>
        <v-col cols="6">
          <time>{{ format_date_display(info.date) }}</time>
          <div>{{ info.content }}</div>
        </v-col> -->
        <!-- 区切り線 -->
        <!-- <v-col offset="1" cols="10" xl="8">
          <v-divider></v-divider>
        </v-col>
      </v-row> -->

    </v-container>
  </div>
</template>

<script>
// import jquery from 'jquery';
// import config from '@/config.js'
import inf from './data/information.js'
import img from './data/home_carousel_images.js'
export default {
  name: "Home",
  data: () => ({
    items: img.images,
    infos: inf.infos,
  }),
  methods: {
    smoothScroll(target) {
      const element = document.getElementById(target);
      const offset = element.offsetTop; // オフセット位置を取得

      window.scrollTo({
        top: offset,
        behavior: 'smooth' // スムーズスクロールを有効にする
    });
    },
    formatDate(date) {
      const year = date.slice(0, 4);
      const month = parseInt(date.slice(4, 6), 10);
      const day = parseInt(date.slice(6, 8), 10);

      const months = [
        "1月", "2月", "3月", "4月", "5月", "6月",
        "7月", "8月", "9月", "10月", "11月", "12月"
      ];

      return `${year}年${months[month - 1]}${day}日`;
    },
  }
  // mounted: function () {
  //   this.load_information();
  // },
  // methods: {
  //   load_information: function () {
  //     const endpoint = config.BASE_API_URL + "/api/information";
  //     jquery.ajax({
  //       type: 'GET',
  //       url: endpoint,
  //       dataType: "json",
  //     }).done((data) => {
  //       this.$set(this.informations, "datas", data);
  //     });
  //   },
  //   format_date_display: function (date) {
  //     const d = date.split('-');
  //     const year = Number(d[0]);
  //     const month = Number(d[1]);
  //     const day = Number(d[2]);
  //     const dayOfWeekJPList = ["日", "月", "火", "水", "木", "金", "土"];
  //     const dateObj = new Date(year, month - 1, day);
  //     const dayOfWeek = dayOfWeekJPList[dateObj.getDay()];
  //     return year + "年" + month + "月" + day + "日" + "（" + dayOfWeek + "）";
  //   }
  // }
};
</script>

<style scoped>
.info {
  text-align: center;
}

.heading {
  border-bottom: 2px solid #000;
}

.carousel {
  aspect-ratio: 4 / 3;
}

.submenu {
  position:sticky;
  top:20%;
}
</style>